import {
    LOGIN_PROGRESS, LOGOUT_PROGRESS,
    GET_BANK_LIST_PROGRESS, ADD_BANK_PROGRESS, EDIT_DELETE_BANK_PROGRESS,
    GET_UNIT_LIST_PROGRESS, ADD_UNIT_PROGRESS, EDIT_DELETE_UNIT_PROGRESS,
    GET_BIN_LIST_PROGRESS, ADD_BIN_PROGRESS, EDIT_DELETE_BIN_PROGRESS,
    GET_STORE_LIST_PROGRESS, ADD_STORE_PROGRESS, EDIT_DELETE_STORE_PROGRESS,
    GET_REJECT_LIST_PROGRESS, ADD_REJECT_PROGRESS, EDIT_DELETE_REJECT_PROGRESS,
    GET_ITEM_LIST_PROGRESS, ADD_ITEM_PROGRESS, EDIT_DELETE_ITEM_PROGRESS,
    GET_ACCOUNT_MANAGER_LIST_PROGRESS, ADD_ACCOUNT_MANAGER_PROGRESS, EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS,
    GET_TERMS_CONDITIONS_LIST_PROGRESS, ADD_TERMS_CONDITIONS_PROGRESS, EDIT_DELETE_TERMS_CONDITIONS_PROGRESS,
    GET_CATEGORY_LIST_PROGRESS, ADD_CATEGORY_PROGRESS, EDIT_DELETE_CATEGORY_PROGRESS,
    GET_CUSTOMER_LIST_PROGRESS, ADD_CUSTOMER_PROGRESS, EDIT_DELETE_CUSTOMER_PROGRESS,
    GET_SUPPLIER_LIST_PROGRESS, ADD_SUPPLIER_PROGRESS, EDIT_DELETE_SUPPLIER_PROGRESS,

    // -------------------settings----------------
    GET_COMPANY_DETAILS_LIST_PROGRESS, ADD_COMPANY_DETAILS_PROGRESS, EDIT_DELETE_COMPANY_DETAILS_PROGRESS,
    GET_DOC_NO_FORMATE_LIST_PROGRESS, ADD_DOC_NO_FORMATE_PROGRESS, EDIT_DELETE_DOC_NO_FORMATE_PROGRESS,
    GET_INVOICE_SETTING_LIST_PROGRESS, ADD_INVOICE_SETTING_PROGRESS, EDIT_DELETE_INVOICE_SETTING_PROGRESS,
    GET_MENU_SETTING_LIST_PROGRESS, ADD_MENU_SETTING_PROGRESS, EDIT_DELETE_MENU_SETTING_PROGRESS,
    GET_INVOICE_TITLE_LIST_PROGRESS, ADD_INVOICE_TITLE_PROGRESS, EDIT_DELETE_INVOICE_TITLE_PROGRESS,
    GET_PURCHASE_SETTING_LIST_PROGRESS, ADD_PURCHASE_SETTING_PROGRESS, EDIT_DELETE_PURCHASE_SETTING_PROGRESS,
    GET_USER_MANAGEMENT_LIST_PROGRESS, ADD_USER_MANAGEMENT_PROGRESS, EDIT_DELETE_USER_MANAGEMENT_PROGRESS,
    GET_ALL_USER_MANAGEMENT_LIST_PROGRESS,
    // -------------------Purchase----------------
    GET_PURCHASE_INVOICE_LIST_PROGRESS, ADD_PURCHASE_INVOICE_PROGRESS, EDIT_DELETE_PURCHASE_INVOICE_PROGRESS,
    GET_PURCHASE_ORDER_LIST_PROGRESS, ADD_PURCHASE_ORDER_PROGRESS, EDIT_DELETE_PURCHASE_ORDER_PROGRESS,
    GET_PURCHASE_RETURN_LIST_PROGRESS, ADD_PURCHASE_RETURN_PROGRESS, EDIT_DELETE_PURCHASE_RETURN_PROGRESS,


    // -------------------Sales----------------
    GET_DELIVERY_CHALLAN_LIST_PROGRESS, ADD_DELIVERY_CHALLAN_PROGRESS, EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS,
    GET_PROFORMA_INVOICE_LIST_PROGRESS, ADD_PROFORMA_INVOICE_PROGRESS, EDIT_DELETE_PROFORMA_INVOICE_PROGRESS,
    GET_QUOTATION_LIST_PROGRESS, ADD_QUOTATION_PROGRESS, EDIT_DELETE_QUOTATION_PROGRESS,
    GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_PROGRESS, ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS, EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS,
    GET_PAYMENT_INVOICE_DEDUCTION_LIST_PROGRESS, ADD_PAYMENT_INVOICE_DEDUCTION_PROGRESS, EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_PROGRESS,
    GET_SALE_INVOICE_LIST_PROGRESS, ADD_SALE_INVOICE_PROGRESS, EDIT_DELETE_SALE_INVOICE_PROGRESS,
    GET_SALES_ORDER_LIST_PROGRESS, ADD_SALES_ORDER_PROGRESS, EDIT_DELETE_SALES_ORDER_PROGRESS,
    GET_SALES_RETURN_LIST_PROGRESS, ADD_SALES_RETURN_PROGRESS, EDIT_DELETE_SALES_RETURN_PROGRESS, GET_CNS_LIST_PROGRESS, ADD_CNS_PROGRESS, EDIT_DELETE_CNS_PROGRESS, GET_STATES_LIST_PROGRESS, GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_PROGRESS, ADD_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS, EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS,
     UPLOAD_FILE_ATTACHMENT_PROGRESS, GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_PROGRESS,
      GET_MAIL_SETUP_LIST_PROGRESS, ADD_MAIL_SETUP_PROGRESS, EDIT_DELETE_MAIL_SETUP_PROGRESS,
       UPLOAD_BANK_EXCEL_PROGRESS, GET_GST_REGESTER_REPORT_PROGRESS, GET_OUTSTANDING_REPORT_PROGRESS,
        GET_PAYMENT_REGISTER_REPORT_PROGRESS, GET_ACCOUNT_STATEMENT_REPORT_PROGRESS, 
        GET_SALES_REGISTER_REPORT_PROGRESS, GET_PURCHASE_REGISTER_REPORT_PROGRESS, 
        GET_SALES_ORDER_HISTORY_REPORT_PROGRESS, GET_PURCHASE_ORDER_HISTORY_REPORT_PROGRESS, 
        UPLOAD_CNS_EXCEL_PROGRESS, UPLOAD_ITEMS_EXCEL_PROGRESS, UPLOAD_USER_EXCEL_PROGRESS, 
        GET_PRINT_SETUP_LIST_PROGRESS, ADD_PRINT_SETUP_PROGRESS, EDIT_DELETE_PRINT_SETUP_PROGRESS,
         FOOTER_PRINT_SETUP_PROGRESS, SIGNATURE_PRINT_SETUP_PROGRESS, WATERMARK_PRINT_SETUP_PROGRESS,
          GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
           GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
            GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS, 
            GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
             GET_DOC_NO_FORMATE_AVAILABLE_PROGRESS, GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_PROGRESS,
              GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_PROGRESS, 
              GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_PROGRESS,
               GET_PRODUCTION_LIST_PROGRESS, ADD_PRODUCTION_PROGRESS, EDIT_DELETE_PRODUCTION_PROGRESS, 
               GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
               MAIL_SEND_ATTACHMENT_PROGRESS,
               GET_NOTIFICATIONS_PROGRESS,
               GET_AGE_OF_UNPAID_INVOICE_PROGRESS,


} from '../types/actionTypes';

export const login = (record) => ({
    type: LOGIN_PROGRESS,
    payload: record,
});

export const logout = (record) => ({
    type: LOGOUT_PROGRESS,
    payload: record,
});

export const getStateList = () => {
    return {
        type: GET_STATES_LIST_PROGRESS,
    };
}

export const getMailSetupList = (record) => {
    return {
        type: GET_MAIL_SETUP_LIST_PROGRESS,
        payload: record,
    };
}

export const addMailSetup = (record) => ({
    type: ADD_MAIL_SETUP_PROGRESS,
    payload: record,
});

export const editDeleteMailSetup = (record) => ({
    type: EDIT_DELETE_MAIL_SETUP_PROGRESS,
    payload: record,
});

// ====================== Bank ===============================

export const getBankList = (record) => {
    return {
        type: GET_BANK_LIST_PROGRESS,
        payload: record,
    };
}

export const addBank = (record) => ({
    type: ADD_BANK_PROGRESS,
    payload: record,
});

export const editDeleteBank = (record) => ({
    type: EDIT_DELETE_BANK_PROGRESS,
    payload: record,
});


// ====================== Unit ===============================
export const getUnitList = (record) => {
    return {
        type: GET_UNIT_LIST_PROGRESS,
        payload: record,
    };
}

export const addUnit = (record) => ({
    type: ADD_UNIT_PROGRESS,
    payload: record,
});

export const editDeleteUnit = (record) => ({
    type: EDIT_DELETE_UNIT_PROGRESS,
    payload: record,
});

// ====================== Bin ===============================
export const getBinList = (record) => {
    return {
        type: GET_BIN_LIST_PROGRESS,
        payload: record,
    };
}

export const addBin = (record) => ({
    type: ADD_BIN_PROGRESS,
    payload: record,
});

export const editDeleteBin = (record) => ({
    type: EDIT_DELETE_BIN_PROGRESS,
    payload: record,
});

// ====================== Store ===============================

export const getStoreList = (record) => {
    return {
        type: GET_STORE_LIST_PROGRESS,
        payload: record,
    };
}

export const addStore = (record) => ({
    type: ADD_STORE_PROGRESS,
    payload: record,
});

export const editDeleteStore = (record) => ({
    type: EDIT_DELETE_STORE_PROGRESS,
    payload: record,
});

// ====================== Reject ===============================
export const getRejectList = (record) => {
    return {
        type: GET_REJECT_LIST_PROGRESS,
        payload: record,
    };
}

export const addReject = (record) => ({
    type: ADD_REJECT_PROGRESS,
    payload: record,
});

export const editDeleteReject = (record) => ({
    type: EDIT_DELETE_REJECT_PROGRESS,
    payload: record,
});

// ====================== Item ===============================
export const getItemList = (record) => {
    return {
        type: GET_ITEM_LIST_PROGRESS,
        payload: record,
    };
}

export const addItem = (record) => ({
    type: ADD_ITEM_PROGRESS,
    payload: record,
});

export const editDeleteItem = (record) => ({
    type: EDIT_DELETE_ITEM_PROGRESS,
    payload: record,
});

// ====================== Account Manager ===============================
export const getAccountManagerList = (record) => {
    return {
        type: GET_ACCOUNT_MANAGER_LIST_PROGRESS,
        payload: record,
    };
}

export const addAccountManager = (record) => ({
    type: ADD_ACCOUNT_MANAGER_PROGRESS,
    payload: record,
});

export const editDeleteAccountManager = (record) => ({
    type: EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS,
    payload: record,
});

// ====================== Terms & Conditions ===============================
export const getTermsConditionsList = (record) => {
    return {
        type: GET_TERMS_CONDITIONS_LIST_PROGRESS,
        payload: record,
    };
}

export const addTermsConditions = (record) => ({
    type: ADD_TERMS_CONDITIONS_PROGRESS,
    payload: record,
});

export const editDeleteTermsConditions = (record) => ({
    type: EDIT_DELETE_TERMS_CONDITIONS_PROGRESS,
    payload: record,
});

// ====================== Category ===============================
export const getCategoryList = (record) => {
    return {
        type: GET_CATEGORY_LIST_PROGRESS,
        payload: record,
    };
}

export const addCategory = (record) => ({
    type: ADD_CATEGORY_PROGRESS,
    payload: record,
});

export const editDeleteCategory = (record) => ({
    type: EDIT_DELETE_CATEGORY_PROGRESS,
    payload: record,
});

// ====================== Customer ===============================
export const getCustomerList = (record) => {
    return {
        type: GET_CUSTOMER_LIST_PROGRESS,
        payload: record,
    };
}

export const addCustomer = (record) => ({
    type: ADD_CUSTOMER_PROGRESS,
    payload: record,
});

export const editDeleteCustomer = (record) => ({
    type: EDIT_DELETE_CUSTOMER_PROGRESS,
    payload: record,
});

// ====================== Supplier ===============================
export const getSupplierList = (record) => {
    return {
        type: GET_SUPPLIER_LIST_PROGRESS,
        payload: record,
    };
}

export const addSupplier = (record) => ({
    type: ADD_SUPPLIER_PROGRESS,
    payload: record,
});

export const editDeleteSupplier = (record) => ({
    type: EDIT_DELETE_SUPPLIER_PROGRESS,
    payload: record,
});

// ====================== Customer and Supplier (Combine) ===============================
export const getCNSList = (record) => {
    return {
        type: GET_CNS_LIST_PROGRESS,
        payload: record,
    };
}

export const addCNS = (record) => ({
    type: ADD_CNS_PROGRESS,
    payload: record,
});

export const editDeleteCNS = (record) => ({
    type: EDIT_DELETE_CNS_PROGRESS,
    payload: record,
});

// ======================Settings ================================
// ====================== Company Details===============================
export const getCompanyList = (record) => {
    return {
        type: GET_COMPANY_DETAILS_LIST_PROGRESS,
        payload: record,
    };
}

export const addCompany = (record) => ({
    type: ADD_COMPANY_DETAILS_PROGRESS,
    payload: record,
});

export const editDeleteCompany = (record) => ({
    type: EDIT_DELETE_COMPANY_DETAILS_PROGRESS,
    payload: record,
});

// ====================== Doc No Formate===============================
export const getDocNoFormateAvailable = (record) => {
    return {
        type: GET_DOC_NO_FORMATE_AVAILABLE_PROGRESS,
        payload: record,
    };
}

export const getDocNoFormateList = (record) => {
    return {
        type: GET_DOC_NO_FORMATE_LIST_PROGRESS,
        payload: record,
    };
}

export const addDocNoFormate = (record) => ({
    type: ADD_DOC_NO_FORMATE_PROGRESS,
    payload: record,
});

export const editDeleteDocNoFormate = (record) => ({
    type: EDIT_DELETE_DOC_NO_FORMATE_PROGRESS,
    payload: record,
});


// ====================== Invoice Setting===============================
export const getInvoiceSettingList = (record) => {
    return {
        type: GET_INVOICE_SETTING_LIST_PROGRESS,
        payload: record,
    };
}

export const addInvoiceSetting = (record) => ({
    type: ADD_INVOICE_SETTING_PROGRESS,
    payload: record,
});

export const editInvoiceSetting = (record) => ({
    type: EDIT_DELETE_INVOICE_SETTING_PROGRESS,
    payload: record,
});

// ====================== Menu Setting===============================
export const getMenuSettingList = (record) => {
    return {
        type: GET_MENU_SETTING_LIST_PROGRESS,
        payload: record,
    };
}

export const addMenuSetting = (record) => ({
    type: ADD_MENU_SETTING_PROGRESS,
    payload: record,
});

export const editMenuSetting = (record) => ({
    type: EDIT_DELETE_MENU_SETTING_PROGRESS,
    payload: record,
});

// ====================== Invoice Title ===============================
export const getInvoicePrintTitleList = (record) => {
    return {
        type: GET_INVOICE_TITLE_LIST_PROGRESS,
        payload: record,
    };
}

export const addInvoicePrintTitle = (record) => ({
    type: ADD_INVOICE_TITLE_PROGRESS,
    payload: record,
});

export const editPrintInvoiceTitle = (record) => ({
    type: EDIT_DELETE_INVOICE_TITLE_PROGRESS,
    payload: record,
});
// ======================Purchase Setting===============================
export const getPurchaseSettingList = (record) => {
    return {
        type: GET_PURCHASE_SETTING_LIST_PROGRESS,
        payload: record,
    };
}

export const addPurchaseSetting = (record) => ({
    type: ADD_PURCHASE_SETTING_PROGRESS,
    payload: record,
});

export const editDeletePurchaseSetting = (record) => ({
    type: EDIT_DELETE_PURCHASE_SETTING_PROGRESS,
    payload: record,
});
// ====================== User Management===============================
export const getUserManagementList = (record) => {
    return {
        type: GET_USER_MANAGEMENT_LIST_PROGRESS,
        payload: record,
    };
}
export const getAllUserManagementList = (record) => {
    return {
        type: GET_ALL_USER_MANAGEMENT_LIST_PROGRESS,
        payload: record,
    };
}
export const addUserManagement = (record) => ({
    type: ADD_USER_MANAGEMENT_PROGRESS,
    payload: record,
});

export const editDeleteUserManagement = (record) => ({
    type: EDIT_DELETE_USER_MANAGEMENT_PROGRESS,
    payload: record,
});


// -------------------Purchase -----------
// ====================== Purchase Invoice ===============================
export const getPurchaseInvoiceList = (record) => {
    return {
        type: GET_PURCHASE_INVOICE_LIST_PROGRESS,
        payload: record,
    };
}

export const addPurchaseInvoice = (record) => ({
    type: ADD_PURCHASE_INVOICE_PROGRESS,
    payload: record,
});

export const editDeletePurchaseInvoice = (record) => ({
    type: EDIT_DELETE_PURCHASE_INVOICE_PROGRESS,
    payload: record,
});

// ====================== Purchase Order===============================
export const getPurchaseOrderList = (record) => {
    return {
        type: GET_PURCHASE_ORDER_LIST_PROGRESS,
        payload: record,
    };
}

export const addPurchaseOrder = (record) => ({
    type: ADD_PURCHASE_ORDER_PROGRESS,
    payload: record,
});

export const editDeletePurchaseOrder = (record) => ({
    type: EDIT_DELETE_PURCHASE_ORDER_PROGRESS,
    payload: record,
});

// ====================== User Management===============================
export const getPurchaseReturnList = (record) => {
    return {
        type: GET_PURCHASE_RETURN_LIST_PROGRESS,
        payload: record,
    };
}

export const addPurchaseReturn = (record) => ({
    type: ADD_PURCHASE_RETURN_PROGRESS,
    payload: record,
});

export const editDeletePurchaseReturn = (record) => ({
    type: EDIT_DELETE_PURCHASE_RETURN_PROGRESS,
    payload: record,
});


// -------------------Sales -----------
// ====================== Delivery Challan ===============================
export const getDeliveryChallanList = (record) => {
    return {
        type: GET_DELIVERY_CHALLAN_LIST_PROGRESS,
        payload: record,
    };
}

export const addDeliveryChallan = (record) => ({
    type: ADD_DELIVERY_CHALLAN_PROGRESS,
    payload: record,
});

export const editDeleteDeliveryChallan = (record) => ({
    type: EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS,
    payload: record,
});

export const getDeliveryChallanItemDescriptionForManualEntry = (record) => {
    return {
        type: GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
        payload: record,
    };
}
// ====================== Proforma Invoice ===============================
export const getProformaInvoiceList = (record) => {
    return {
        type: GET_PROFORMA_INVOICE_LIST_PROGRESS,
        payload: record,
    };
}

export const addProformaInvoice = (record) => ({
    type: ADD_PROFORMA_INVOICE_PROGRESS,
    payload: record,
});

export const editDeleteProformaInvoice = (record) => ({
    type: EDIT_DELETE_PROFORMA_INVOICE_PROGRESS,
    payload: record,
});

export const getProformaItemDescriptionForManualEntry = (record) => {
    return {
        type: GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
        payload: record,
    };
}
// ====================== Quotation ===============================
export const getQuotationList = (record) => {
    return {
        type: GET_QUOTATION_LIST_PROGRESS,
        payload: record,
    };
}

export const addQuotation = (record) => ({
    type: ADD_QUOTATION_PROGRESS,
    payload: record,
});

export const editDeleteQuotation = (record) => ({
    type: EDIT_DELETE_QUOTATION_PROGRESS,
    payload: record,
});

export const getQuotationItemDescriptionForManualEntry = (record) => {
    return {
        type: GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
        payload: record,
    };
}
// ====================== Customer and Supplier Advance Payment ===============================
export const getCustomerSupplierAdvancePaymentList = (record) => {
    return {
        type: GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_PROGRESS,
        payload: record,
    };
}

export const addCustomerSupplierAdvancePayment = (record) => ({
    type: ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS,
    payload: record,
});

export const editDeleteCustomerSupplierAdvancePayment = (record) => ({
    type: EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS,
    payload: record,
});


// ====================== Customer and Supplier Payment ===============================
export const getCustomerSupplierPaymentList = (record) => {
    return {
        type: GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_PROGRESS,
        payload: record,
    };
}

export const addCustomerSupplierPayment = (record) => ({
    type: ADD_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS,
    payload: record,
});

export const editDeleteCustomerSupplierPayment = (record) => ({
    type: EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS,
    payload: record,
});

export const UploadFileAttachment = (record) => ({
    type: UPLOAD_FILE_ATTACHMENT_PROGRESS,
    payload: record,
});

export const getCustomerSupplierPendingPaymentList = (record) => {
    return {
        type: GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_PROGRESS,
        payload: record,
    };
}

// ====================== Sale Payment ===============================
export const getPaymentInvoiceDeduction = (record) => {
    return {
        type: GET_PAYMENT_INVOICE_DEDUCTION_LIST_PROGRESS,
        payload: record,
    };
}

export const addPaymentInvoiceDeduction = (record) => ({
    type: ADD_PAYMENT_INVOICE_DEDUCTION_PROGRESS,
    payload: record,
});

export const editDeletePaymentInvoiceDeduction = (record) => ({
    type: EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_PROGRESS,
    payload: record,
});

// ====================== Sale Invoice ===============================
export const getSaleInvoiceList = (record) => {
    return {
        type: GET_SALE_INVOICE_LIST_PROGRESS,
        payload: record,
    };
}

export const addSaleInvoice = (record) => ({
    type: ADD_SALE_INVOICE_PROGRESS,
    payload: record,
});

export const editDeleteSaleInvoice = (record) => ({
    type: EDIT_DELETE_SALE_INVOICE_PROGRESS,
    payload: record,
});

export const getSalesItemDescriptionForManualEntry = (record) => {
    return {
        type: GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
        payload: record,
    };
}

export const getAgeOfUnpaidInvoice= (record) => {
    return {
        type: GET_AGE_OF_UNPAID_INVOICE_PROGRESS,
        payload: record,
    };
}

// ====================== Sales Order ===============================
export const getSalesOrderList = (record) => {
    return {
        type: GET_SALES_ORDER_LIST_PROGRESS,
        payload: record,
    };
}

export const addSalesOrder = (record) => ({
    type: ADD_SALES_ORDER_PROGRESS,
    payload: record,
});

export const editDeleteSalesOrder = (record) => ({
    type: EDIT_DELETE_SALES_ORDER_PROGRESS,
    payload: record,
});

export const getSalesOrderItemDescriptionForManualEntry = (record) => {
    return {
        type: GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,
        payload: record,
    };
}
// ====================== Sales Return ===============================
export const getSalesReturnList = (record) => {
    return {
        type: GET_SALES_RETURN_LIST_PROGRESS,
        payload: record,
    };
}

export const addSalesReturn = (record) => ({
    type: ADD_SALES_RETURN_PROGRESS,
    payload: record,
});

export const editDeleteSalesReturn = (record) => ({
    type: EDIT_DELETE_SALES_RETURN_PROGRESS,
    payload: record,
});

// -------------------Reports -----------
// ====================== sales Register ===============================
export const getSalesRegisterReport = (record) => {
    return {
        type: GET_SALES_REGISTER_REPORT_PROGRESS,
        payload: record,
    };
}

// ====================== purchase Register ===============================
export const getPurchaseRegisterReport = (record) => {
    return {
        type: GET_PURCHASE_REGISTER_REPORT_PROGRESS,
        payload: record,
    };
}

// ====================== Sales Order History ===============================
export const getSalesOrderHistoryReport = (record) => {
    return {
        type: GET_SALES_ORDER_HISTORY_REPORT_PROGRESS,
        payload: record,
    };
}

// ====================== Purchase Order History ===============================
export const getPurchaseOrderHistoryReport = (record) => {
    return {
        type: GET_PURCHASE_ORDER_HISTORY_REPORT_PROGRESS,
        payload: record,
    };
}
// ====================== Account Statement ===============================
export const getAccountStatementReport = (record) => {
    return {
        type: GET_ACCOUNT_STATEMENT_REPORT_PROGRESS,
        payload: record,
    };
}

// ====================== Payment Register ===============================
export const getPaymentRegisterReport = (record) => {
    return {
        type: GET_PAYMENT_REGISTER_REPORT_PROGRESS,
        payload: record,
    };
}

// ====================== Outstanding ===============================
export const getOutstandingReport = (record) => {
    return {
        type: GET_OUTSTANDING_REPORT_PROGRESS,
        payload: record,
    };
}

// ====================== GST Register ===============================
export const getGSTRegisterReport = (record) => {
    return {
        type: GET_GST_REGESTER_REPORT_PROGRESS,
        payload: record,
    };
}


// Upload excel sheet 
export const uploadBankExcel = (record) => ({
    type: UPLOAD_BANK_EXCEL_PROGRESS,
    payload: record,
});

export const uploadCNSExcel = (record) => ({
    type: UPLOAD_CNS_EXCEL_PROGRESS,
    payload: record,
});

export const uploadItemExcel = (record) => ({
    type: UPLOAD_ITEMS_EXCEL_PROGRESS,
    payload: record,
});

export const uploadUserExcel = (record) => ({
    type: UPLOAD_USER_EXCEL_PROGRESS,
    payload: record,
});

// Print Setup Setting 
export const getPrintSetupList = (record) => {
    return {
        type: GET_PRINT_SETUP_LIST_PROGRESS,
        payload: record,
    };
}

export const addPrintSetup = (record) => ({
    type: ADD_PRINT_SETUP_PROGRESS,
    payload: record,
});

export const editPrintSetup = (record) => ({
    type: EDIT_DELETE_PRINT_SETUP_PROGRESS,
    payload: record,
});

export const UploadAttachmentWatermark = (record) => ({
    type: WATERMARK_PRINT_SETUP_PROGRESS,
    payload: record,
});

export const UploadAttachmentFooter = (record) => ({
    type: FOOTER_PRINT_SETUP_PROGRESS,
    payload: record,
});

export const UploadAttachmentSignature = (record) => ({
    type: SIGNATURE_PRINT_SETUP_PROGRESS,
    payload: record,
});
// Dashboard 
export const getTotalReceivablePayableDashboard = (record) => {
    return {
        type: GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_PROGRESS,
        payload: record,
    };
}
export const getMonthAndCustomerWiseSalesDashboard = (record) => {
    return {
        type: GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_PROGRESS,
        payload: record,
    };
}

export const getMonthAndCustomerWisePurchaseDashboard = (record) => {
    return {
        type: GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_PROGRESS,
        payload: record,
    };
}
// -------------------Production -----------
// ====================== Production ===============================
export const getProductionList = (record) => {
    return {
        type: GET_PRODUCTION_LIST_PROGRESS,
        payload: record,
    };
}

export const addProduction = (record) => ({
    type: ADD_PRODUCTION_PROGRESS,
    payload: record,
});

export const editDeleteProduction = (record) => ({
    type: EDIT_DELETE_PRODUCTION_PROGRESS,
    payload: record,
});

export const sendMailAttachment = (record) => ({
    type: MAIL_SEND_ATTACHMENT_PROGRESS,
    payload: record,
});

export const getNotifications = (record) => {
    return {
        type: GET_NOTIFICATIONS_PROGRESS,
        payload: record,
    };
}